export const assuranceEngineMessages = {
  en: {
    title: 'Assurance Engine for snapshot discovery',
    description:
      'Disabling the options below can improve speed when creating & computing snapshots, however it could have negative impact on product functionality.',
    toggleMessages: {
      on: 'Enabled',
      off: 'Disabled',
    },
    loadingGraphCache: {
      title: 'Loading Graph cache',
      description:
        'If disabled, post-discovery computations will be faster, but loading diagrams in the Network Viewer and Path Lookup might take some additional time as computations are done on demand.',
    },
    saveHistoricalData: {
      title: 'Save historical data',
      description:
        'Slightly faster if disabled, could have impact on some tables though.',
    },
    computeIntentVerificationRules: {
      title: 'Compute Intent Verification Rules',
      description:
        'Disable to have faster snapshot. It could have some impact on table views, graphs and cell coloring.',
    },
    btnSave: 'Save Settings',
    request: {
      settingsSaved: 'Assurance Engine settings saved',
    },
  },
};
